<template>
  <div>
    <Subheader title="Карточка пользователя" :backBtn="{ route: { path: '/manage/users' } }" />
    <div class="col-12">
      <div class="row mb-2">
        <!-- AVATAR -->
        <div class="col-12 col-md-3 d-flex flex-column align-items-center">
          <div class="card w-100 mb-3">
            <div class="card-body">
              <h3>{{ ((form.last_name && form.last_name + " ") || "") + form.first_name }}</h3>
              <avatar-editor v-if="avatar" v-model="avatar" :displayOnly="true" />
              <div class="common-primary mt-3">
                <div v-if="common.referal" class="inviter">Пригласивший пользователь: {{ common.referal }}</div>
              </div>
            </div>
          </div>

          <b-button variant="primary" @click="() => performShadowLogin()" class="w-100">
            Залогиниться под пользователем
          </b-button>
        </div>

        <div class="col-12 mt-4 col-md-5 mt-md-0">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Фамилия</div>
                <div class="col-9">
                  <b-form-input v-model="form.last_name" type="text" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Имя</div>
                <div class="col-9">
                  <b-form-input v-model="form.first_name" type="text" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Отчество</div>
                <div class="col-9">
                  <b-form-input v-model="form.second_name" type="text" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Email</div>
                <div class="col-9">
                  <b-form-input v-model="form.email" type="text" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Телефон</div>
                <div class="col-9">
                  <b-form-input v-model="form.phone" type="text" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3 d-flex align-items-center justify-content-end">Страна</div>
                <div class="col-9">
                  <b-form-input v-model="form.country" type="text" trim />
                </div>
              </div>
              <div class="row m-0 justify-content-end">
                <b-button variant="primary" @click="save()" class="mx-3">Сохранить </b-button>
              </div>
            </div>
          </div>
          <div class="card mt-4">
            <div class="card-body">
              <h5 class="card-title">Проекты</h5>
              <div class="row">
                <div class="col-12 mb-2" v-for="{ id, name, services } of projects" :key="id">
                  <span>#{{ id }}. {{ name }}</span>
                  <p v-for="{ id, name, duration } of services" :key="id" class="ml-5">
                    <span>{{ name }}</span>
                    <span class="text-muted"> ({{ duration }})</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4 col-md-4 mt-md-0">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">Сменить пароль</h5>
              <div class="row mb-2">
                <div class="col-3">Новый пароль</div>
                <div class="col-9">
                  <b-form-input v-model="password.new_password" type="password" trim />
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-3">Новый пароль (повторно)</div>
                <div class="col-9">
                  <b-form-input v-model="password.new_password_repeat" type="password" trim />
                </div>
              </div>
              <div class="row">
                <div class="col-3" />
                <div class="col-9">
                  <b-button variant="primary" @click="changePassword">Сменить пароль </b-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="organization" class="card mt-4">
            <div class="card-body">
              <h5 class="card-title">Организация</h5>
              <div v-if="organizationForms" class="row mb-2">
                <div class="col-5">Юридический статус</div>
                <div class="col-7">
                  {{ organizationForms.find(({ id }) => organization.form_id === id).name }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-5">Имя</div>
                <div class="col-7">
                  {{ organization.name }}
                </div>
              </div>
              <div v-if="organization.inn" class="row mb-2">
                <div class="col-5">ИНН</div>
                <div class="col-7">
                  {{ organization.inn }}
                </div>
              </div>
              <div v-if="organization.phone" class="row mb-2">
                <div class="col-5">Телефон</div>
                <div class="col-7">
                  <span>{{ organization.phone }}</span>
                  <span class="text-muted" style="font-size: 0.9rem">
                    ({{ organization.phone_verified ? "подтвержден" : "не подтвержден" }})
                  </span>
                </div>
              </div>
              <template v-if="organization.form_id === PHYSIC && organization.document">
                <div class="row mb-2 align-items-center">
                  <div class="col-5">Дата рождения</div>
                  <div class="col-7">
                    {{ getFormattedDate(organization.document.birthday) }}
                  </div>
                </div>
                <div class="row mb-2 align-items-center">
                  <div class="col-5">Серия и номер паспорта</div>
                  <div class="col-7">
                    {{ organization.document.number }}
                  </div>
                </div>
                <div class="row mb-2 align-items-center">
                  <div class="col-5">Кем выдан</div>
                  <div class="col-7">
                    {{ organization.document.issuer }}
                  </div>
                </div>
                <div class="row mb-2 align-items-center">
                  <div class="col-5">Дата выдачи</div>
                  <div class="col-7">
                    {{ getFormattedDate(organization.document.date_issue) }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12 d-flex justify-content-between">
                    <a :href="organization.document.passport_photo" target="_blank">Скан документа</a>
                    <a :href="organization.document.passport_selfie" target="_blank">Селфи-фото с паспортом</a>
                  </div>
                </div>
              </template>
              <div class="row mb-2 align-items-center">
                <div class="col-5">Статус</div>
                <div class="col-7">
                  <b-form-select
                    v-if="!organization.verification.is_auto"
                    v-model="organization.verification.state_id"
                    :options="verificationRequestStates"
                    value-field="id"
                    text-field="name"
                  />
                  <span v-else> {{ verificationRequestStates.find(({ id }) => id === organization.verification.state_id).name }} </span>
                </div>
                <b-form-textarea
                  v-if="organization.verification.state_id === VERIFICATION_CANCELED"
                  v-model="organization.verification.message"
                  placeholder="Причина отклонения"
                  class="mx-2 mt-1"
                />
              </div>
              <div v-if="!organization.verification.is_auto" class="row">
                <div class="col-5"></div>
                <div class="col-7">
                  <b-button variant="primary" @click="saveVerification">Сохранить</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Api from "shared/service/api/api";
import { mapGetters } from "vuex";
import dateMixin from "shared/service/mixins/date.mixin";

import AvatarEditor from "shared/widgets/upload/image/AvatarEditor";
import Subheader from "shared/layout/subheader/Subheader.vue";
import { SHADOW_LOGIN } from "shared/store/modules/auth.store";
import {
  ORGANIZATION_PHYSIC_FORM as PHYSIC,
  VERIFICATION_REQUEST_CANCELED_STATE as VERIFICATION_CANCELED
} from "shared/service/consts";

export default {
  components: { AvatarEditor, Subheader },
  name: "UserEdit",
  mixins: [dateMixin],
  computed: {
    ...mapGetters("project", ["organizationForms"]),
    ...mapGetters("admin", ["verificationRequestStates"]),
    userId() {
      return Number(this.$route.params.userId);
    },
    kt_portlet() {
      return document.querySelector("div.kt-container>div.kt-portlet");
    },
  },
  data() {
    return {
      avatar: null,
      common: {
        referal: null,
      },
      organization: null,
      projects: [],
      form: {
        id: null,
        first_name: null,
        second_name: null,
        last_name: null,
        email: null,
        phone: null,
        country: null,
      },
      password: {
        new_password: null,
        new_password_repeat: null,
      },
      verificationStateId: null,
      verification: {
        stateId: null,
        message: null
      }
    };
  },
  mounted() {
    this.kt_portlet.style.backgroundColor = "transparent";
    this.kt_portlet.style.boxShadow = "none";
    this.load();
  },
  destroyed() {
    this.kt_portlet.style.backgroundColor = "";
    this.kt_portlet.style.boxShadow = "";
  },
  methods: {
    ...mapActions([SHADOW_LOGIN]),
    load() {
      Api.admin.user
        .one(this.userId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          const data = response.data;

          this.avatar = data.avatar;
          this.form = data.form;
          this.common = data.common;
          this.projects = data.projects;
          this.organization = data.organization;
        })
        .catch(() => {
          this.$alert.error("Ошибка загрузки данных пользователя");
        });
    },
    isValidPassword() {
      if (this.password.new_password.length === 0) {
        this.$alert.error("Пароль не может быть пустым");
        return false;
      }

      if (this.password.new_password !== this.password.new_password_repeat) {
        this.$alert.error("Пароли не совпадают");
        return false;
      }

      return true;
    },
    saveVerification() {
      Api.verification
        .changeState(this.organization.verification.id, this.organization.verification.state_id, this.organization.verification.message)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }
          this.$alert.success('Статус успешно изменён');
          this.load();
        })
        .catch((e) => this.$alert.error("Не удалось изменить статус<br>" + e.message));
    },
    changePassword() {
      if (!this.isValidPassword()) {
        return;
      }

      Api.admin.user
        .changePassword(this.userId, this.password.new_password, this.password.new_password_repeat)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.$alert.success("Пароль успешно сменён");
        })
        .catch((e) => this.$alert.error("Ошибка смены пароля<br>" + e.message));
    },
    save() {
      Api.admin.user
        .save(this.form)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.$alert.success("Пользователь успешно сохранён");
        })
        .catch(() => this.$alert.error("Ошибка сохранения данных пользователя!"));
    },

    performShadowLogin() {
      this[SHADOW_LOGIN](this.form.id)
        .then(() => {
          this.$alert.info("Страница сейчас перезагрузится");
          setTimeout(() => {
            this.$router.push("/").then(() => {
              window.location.reload();
            });
          }, 1000);
        })
        .catch((e) => this.$alert.error(e.message));
    },
  },

  created() {
    this.VERIFICATION_CANCELED = VERIFICATION_CANCELED;
    this.PHYSIC = PHYSIC;
  }
};
</script>
